<template>
  <div class="bg_gray">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="我的二手房交易"
      fontSize="0.32rem"
    />
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner" v-for="(item, index) in list" :key="index">
            <div class="middle m_flex_box flex_vw">
              <div class="row m_flex_box">交易类型<span>{{item.dealTypeStr}}</span></div>
              <div class="row m_flex_box">合同状态<span>{{item.contrStateStr}}</span></div>
              <div class="row m_flex_box">建筑面积<span>{{item.sumArea || '-'}}m²</span></div>
              <div class="row m_flex_box">房屋用途<span>{{item.houseUse || '-'}}</span></div>
              <div class="row_long m_flex_box">房屋区域<span v-html="item.areaStr"></span></div>
              <div class="row_long m_flex_box">申请类别<span v-html="item.operateTypeStr"></span></div>
              <div class="row_long m_flex_box">审核结果<span v-html="item.operateResultStr"></span></div>
              <div class="row_long m_flex_box" v-if="item.msg">驳回原因<span v-html="item.msg"></span></div>
              <div class="row_long m_flex_box">房屋坐落<span>{{item.houseAddress}}</span></div>
            </div>
            <div class="btn_con" v-if="item.buttonShowList.length">
              <div class="arrow left" v-if="item.buttonShowList.length > 3">
                <van-icon name="arrow-left" />
              </div>
              <div class="arrow right" v-if="item.buttonShowList.length > 3">
                <van-icon name="arrow" />
              </div>
              <!-- <span @click="delApply(index)">删除申请</span>
              <span @click="confirm(index)">合同确认申请</span> -->
              <span v-for="inner in item.buttonShowList" :key="inner.buttonType" @click="clickBtn(inner.buttonType, inner)">{{inner.buttonStr}}</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-dialog v-model="show" title="请输入不同意原因" show-cancel-button @confirm="confirm">
      <textarea v-model="msg"></textarea>
    </van-dialog>
    <img class="to_home" @click="$router.replace('/mine')" src="@/assets/img/index/99.png" alt="">
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      currPageNo: 1,
      show: false,
      msg: '',
      id: '',
      restrictedArea: [],
      onlineSignArea: [],
      commissionArea: [],
    };
  },
  components: {
    topHeader
  },
  mounted() {
    this.getAreaList();
  },
  methods: {
    assignmentTooken() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        var token = "";
        for (var i = 0; i < uaList.length; i++) {
          if (uaList[i].indexOf("token") > -1) {
            token = uaList[i].split("=")[1];
            break;
          }
        }
        this.appToken = token;
      } else {
        if ((this.isWx && this.isWx != "false") || this.isWx == "true") {
          if (window.sessionStorage.getItem("wxAppToken")) {
            this.appToken = sessionStorage.getItem("wxAppToken");
          }
        } else {
          if (JSON.parse(window.localStorage.getItem("tokenObj"))) {
            this.appToken = JSON.parse(
              localStorage.getItem("tokenObj")
            ).appToken;
          }
        }
      }
    },
    getAreaList () {
      this.$http.post('cms/onlineUser/permit/areaList.do').then(res => {
        this.restrictedArea = res.obj.restrictedArea;
        this.onlineSignArea = res.obj.onlineSignArea;
        this.commissionArea = res.obj.commissionArea;
      })
    },
    changeType(type) {
      this.current = type
    },
    confirm(id) {
      this.$dialog.confirm({
        confirmButtonColor: "#2F72F5",
        title: "提示",
        message: "您确定取消该预约申请吗？30日内仅允许取消预约1次，请谨慎操作"
      })
      .then(() => {
        this.list.splice(index, 1);
      })
      .catch(() => {
        // on cancel
      });
    },
    delApply(id) {
      this.$dialog.confirm({
        confirmButtonColor: "#2F72F5",
        title: "提示",
        message: "您确定取消该预约申请吗？30日内仅允许取消预约1次，请谨慎操作"
      })
      .then(() => {
        this.list.splice(index, 1);
      })
      .catch(() => {
        // on cancel
      });
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.currPageNo = 1;
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$http({
          url: 'cms/contractOnlineApproval/reg/getContractApprovalShow.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            offset: (this.currPageNo - 1) * 10,
            pageSize: 10
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows);
            this.loading = false;
            this.currPageNo += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },
    clickBtn(type, item) {
       if(type == 1) {
        this.$router.push({
          path: '/showClfContract',
          query: {
            id: item.contractId
          }
        })
      } else if(type == 2) {
          this.$router.push({
            path: '/escrowAgreement',
            query: {
              id: item.contractId
            }
          })
      } else if(type == 3) {
        var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            this.$http.post('cms/contractData/reg/judgeContractDataOnlinePdf.do', qs.stringify({
              contractId: item.contractId
            })).then(data => {
              window.location.href = data.obj + "?contractId=" + data.attributes.contractId + "&id=" + data.attributes.id;
            })
          } else {
            this.$http.post('cms/contractData/reg/getContractDataOnlinePdf.do', qs.stringify({
              contractId: item.contractId
            })).then(data => {
              if(data.success) {
                window.open(data.obj)
              } else {
                this.$dialog.alert({
                  title: '提示',
                message: data.msg
                })
              }
            });
          }
      } else if(type == 4) {
        var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            this.$http.post('cms/superviseFundPrint/reg/judgeFundAgreementPdfOnlineMobile.do', qs.stringify({
              id: item.contractId
            })).then(data => {
              window.location.href = data.obj + "?superviseFundAgreementId=" + data.attributes.superviseFundAgreementId + "&id=" + data.attributes.id;
            })
          } else {
            this.$http.post('cms/superviseFundPrint/reg/doFundAgreementPdfOnlineMobile.do', qs.stringify({
              id: item.contractId
            })).then(data => {
              if(data.success) {
                window.open(data.obj)
              } else {
                this.$dialog.alert({
                  title: '提示',
                  message: data.msg
                })
              }
            });
          }
      } else if(type == 5) {
        var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            this.$http.post('cms/superviseFundPrint/reg/judgeMortgagePdfOnlineMobile.do', qs.stringify({
              id: item.contractId
            })).then(data => {
              window.location.href = data.obj + "?mortgageId=" + data.attributes.mortgageId + "&id=" + data.attributes.id;
            })
          } else {
            this.$http.post('cms/superviseFundPrint/reg/getOnlineMortgagePdf.do', qs.stringify({
              id: item.contractId
            })).then(data => {
              if(data.success) {
                window.open(data.obj)
              } else {
                this.$dialog.alert({
                  title: '提示',
                  message: data.msg
                })
              }
            });
          }
      } else if(type == 6) {
        this.$dialog.confirm({
          title: '提示',
          message: '是否注销申请？',
          confirmButtonText: '注销'
        }).then(res => {
          this.$http.post('cms/contractData/reg/doSendOnlineContractSignLogoutRecord.do', qs.stringify({
            contractId: item.contractId
          })).then(data => {
            this.$toast(data.msg)
            if(data.success) {
              this.onRefresh();
            }
          })
        }).catch(() => {
        });
      } else if(type == 7) {
        this.$dialog.confirm({
          title: '提示',
          message: '是否撤销注销？',
          confirmButtonText: '撤销'
        }).then(res => {
          this.$http({
            url: 'cms/contractData/reg/doApprovalOnlineRepeal.do',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              id: item.contractOnlineApprovalId
            }
          }).then(data => {
            this.$toast(data.msg)
            if(data.success) {
              this.onRefresh();
            }
          })
        }).catch(() => {
        });
      } else if(type == 8) {
        this.$dialog.confirm({
          title: '提示',
          message: '您同意当前的合同注销申请吗',
          confirmButtonText: '同意',
          cancelButtonText: '不同意'
        }).then(res => {
          this.$http({
            url: 'cms/contractData/reg/doApprovalOnlineContractSignLogoutRecord.do',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              id: item.contractOnlineApprovalId,
              state: 1
            }
          }).then(data => {
            this.$toast(data.msg)
            if(data.success) {
              this.onRefresh();
            }
          })
        }).catch(() => {
          this.show = true;
          this.id = item.contractOnlineApprovalId;
        });
      } else if(type == 9) {
        this.$router.push({
          path: '/uploadSign',
          query: {
            id: item.contractId,
          }
        })
      } else if(type == 10) {
        this.$router.push({
          path: '/keepOnRecordApply',
          query: {
            id: item.contractId,
            type: item.contrPayment
          }
        })
      } else if(type == 11) {
        this.$router.push({
          path: '/showClfContract',
          query: {
            id: item.contractId,
            approId: item.contractOnlineApprovalId
          }
        })
      } else if(type == 12) {
        this.$dialog.confirm({
          title: '提示',
          message: '是否撤销合同确认申请？',
          confirmButtonText: '撤销'
        }).then(res => {
          this.$http({
            url: 'cms/contractData/reg/doApprovalOnlineRepeal.do',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: {
              id: item.contractOnlineApprovalId
            }
          }).then(data => {
            this.$toast(data.msg)
            if(data.success) {
              this.onRefresh();
            }
          })
        }).catch(() => {
        });
      } else if(type == 13) {
        this.$router.push({
          path: '/infoCompletion',
          query: {
            id: item.contractId
          }
        })
      } else if(type == 14) {
        this.$dialog.confirm({
          title: '提示',
          message: '是否撤销合同确认申请？',
        }).then(res => {
          this.$http.post('cms/contractData/reg/deleteMyDeal.do', qs.stringify({
            contractId: item.contractId
          })).then(data => {
            this.$toast(data.msg)
            if(data.success) {
              this.onRefresh();
            }
          })
        }).catch(() => {
        });
      } else if(type == 15) {
        this.$router.push({
          path: '/testRealName',
          query: {
            id: item.contractApprovalId,
            type: item.dealType
          }
        })
      } else if(type == 16) {
        this.$router.push({
          path: '/lookInfo',
          query: {
            id: item.contractApprovalId,
            type: item.dealType
          }
        })
      }
    },
    confirm() {
      if(!this.msg) {
        this.$toast('请给出不同意合同注销申请的原因');
        return;
      }
      this.$http({
        url: 'cms/contractData/reg/doApprovalOnlineContractSignLogoutRecord.do',
        method: 'POST',
        headers: {
          "Content-Type": 'application/json'
        },
        data: {
          id: this.id,
          state: 2,
          msg: this.msg
        }
      }).then(res => {
        this.onRefresh()
      })
    },
  }
};
</script>
<style lang="less" scoped>
textarea{
  width: 80%;
  display: block;
  margin: 0.2rem auto;
  border: 1px solid #f5f5f5;
  height: 3.4rem;
  padding: 0.3rem;
  box-sizing: border-box;
}
.bg_gray {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.inner {
  background-color: #fff;
  padding: 0.3rem 0.23rem 0;
  border-bottom: 0.16rem solid #f5f5f5;
  position: relative;
  .top {
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 0.3rem;
    p {
      font-size: 0.26rem;
      width: 70%;
    }
    i {
      color: #52DBB3;
      font-size: 0.22rem;
    }
  }
  .middle {
    padding: 0rem 0 0.1rem;
    border-bottom: 1px solid #f5f5f5;
    .row, .row_long {
      margin-bottom: 0.18rem;
      font-size: 0.26rem;
      span {
        color: #999;
        max-width: 85%;
        padding-left: 0.2rem;
        box-sizing: border-box;
      }
    }
    .row{
      width: 50%;
    }
    .row_long{
      width: 100%;
    }
  }
  .btn_con {
    box-sizing: border-box;
    height: 1.08rem;
    padding: 0.25rem 0.23rem;
    white-space: nowrap;
    overflow: auto;
    text-align: right;
    .arrow{
      position: absolute;
      height: 1.08rem;
      bottom: 0;
      background-color: #fff;
      line-height: 1.08rem;
      &.left{
        left: 0.23rem;
      }
      &.right{
        right: 0.23rem;
      }
      i{
        color: #999;
      }
    }
    span {
      height: 0.58rem;
      padding: 0 0.23rem;
      text-align: center;
      line-height: 0.58rem;
      box-sizing: border-box;
      border: 1px solid #2f72f5;
      color: #2f72f5;
      border-radius: 0.08rem;
      margin-left: 0.14rem;
      display: inline-block;
      // &:last-child {
      //   background-color: #2f72f5;
      //   color: #fff;
      // }
    }
  }
}
</style>